export default __webpack_public_path__ + "static/media/valuer-logo.c82bb4d5.png";